<template>
	<section class="form-news">
		<div class="form-news__container">
			<h2 class="form-news__title" :title="title" v-html="title"></h2>
			<p class="form-news__desc" v-html="description"></p>
			<form id="newsForm">
				<input value="REAL_ESTATE" type="hidden" name="code" />
				<ul class="form-news__list">
					<li class="form-news__fieldset">
						<select-with-search
							:filter-data="regionsData"
							:placeholder="fields.region.placeholder"
							:label="fields.region.label"
							:field-name="fields.region.name"
							:this-component-duble-count="'-2'"
							@choosen-filter-items="regionsHandler"
						/>
						<div
							v-if="errors[fields.region.dataId]"
							class="form-news__error"
							v-html="errors[fields.region.dataId]"
						></div>
					</li>
					<li class="form-news__fieldset">
						<label
							class="form-news__label"
							:for="fields.email.id"
							v-html="fields.email.label"
						></label>
						<div class="form-news__field-wrap">
							<input
								class="form-news__field"
								:type="fields.email.type"
								:id="fields.email.id"
								:name="fields.email.name"
								:placeholder="fields.email.placeholder"
								v-model="fields.email.value"
								@input="
									() => {
										delError(fields.email.dataId)
										showClear(fields.email.dataId)
									}
								"
								autocomplete="off"
								:ref="fields.email.dataId"
								maxlength="100"
							/>
							<button
								v-if="fields.email.clearBtn"
								class="form-news__field-clear clear-btn"
								aria-label="Очистить поле"
								tabindex="-1"
								@click.prevent="
									() => {
										clearField(fields.email.dataId)
										delError(fields.email.dataId)
									}
								"
							></button>
						</div>
						<div
							v-if="errors[fields.email.dataId]"
							class="form-news__error"
							v-html="errors[fields.email.dataId]"
						></div>
					</li>
				</ul>
				<div class="form-news__term">
					<div class="form-news__term-wrap">
						<input
							class="visually-hidden"
							type="checkbox"
							:id="term.field.id"
							:name="term.field.name"
							:value="term.field.value"
							ref="term"
							@change="() => delError(term.field.dataId)"
						/>
						<div class="form-news__term-label-wrap">
							<label
								class="form-news__term-label"
								:for="term.field.id"
								v-html="term.field.label"
							></label>
							<span
								class="form-news__term-link"
								:data-href="idPersPr"
								@click.prevent="showPersModal('s3')"
								v-html="term.field.link.text"
							></span>
							<span> в соответствии с </span>
							<a
								class="form-news__term-link"
								href="/upload/documents/personal_data_process.pdf"
								target="_blank"
							>
								политикой
							</a>
						</div>
					</div>
					<div
						v-if="errors[term.field.dataId]"
						class="form-news__error"
						v-html="errors[term.field.dataId]"
					></div>
				</div>
				<div class="form-news__adv">
					<div class="form-news__adv-wrap">
						<input
							class="visually-hidden"
							type="checkbox"
							:id="adv.field.id"
							:name="adv.field.name"
							:value="adv.field.value"
							ref="adv"
							@change="() => delError(adv.field.dataId)"
						/>
						<div class="form-news__term-label-wrap">
							<label
								class="form-news__term-label"
								:for="adv.field.id"
								v-html="adv.field.label"
							></label>
							<span
									class="form-news__term-link"
									:data-href="idPersPr"
									@click.prevent="showPersModal('zr1')"
									v-html="adv.field.link.text"
							></span>
						</div>
					</div>
					<div
						v-if="errors[adv.field.dataId]"
						class="form-news__error"
						v-html="errors[adv.field.dataId]"
					></div>
				</div>
				<div class="smartcaptcha" ref="smartcaptcha"></div>
				<button
					class="form-news__submit"
					:class="{ disabled: formSubmiting }"
					@click.prevent="submitHandler"
				>
					<span
						v-show="formSubmiting"
						class="form-news__submit-preloader"
						aria-label="Отправка формы"
					></span>
					<span class="form-news__submit-text" v-html="submitBtnText"></span>
				</button>
			</form>
			<div
				v-if="errorResponse.error"
				class="form-news__error"
				v-html="errorResponse.text"
			></div>
		</div>
		<div class="form-news__img">
			<img
				:src="img.src"
				:alt="img.alt"
				:title="img.alt"
				:width="img.width"
				:height="img.height"
			/>
		</div>
	</section>
	<ui-modal
		ref="uiModal"
		:key="showPopupSuccess"
		:target="idPersPr"
		:need-close-button="true"
		class="modal_conditions"
	>
		<template v-if="contentPersPr">
			<div
				class="ui-modal-container__header ui-modal-container__header-conditions"
				v-html="headerTitle"
			></div>
			<div
				class="ui-modal-container__body ui-modal-container__body-conditions"
				v-html="contentPersPr"
			></div>
		</template>
		<template v-else>
			<div class="conditions s3">
				<div class="conditions-inner" style="overflow: hidden">
					загрузка согласия...
					<my-preloader :add-class="'n-py-8 n-px-8'" />
				</div>
			</div>
		</template>
	</ui-modal>
	<Transition>
		<form-success-modal
			v-if="formSuccess"
			:title="successData.title"
			:description="successData.description"
			@hide-modal="hideSuccessModal"
		/>
	</Transition>
	<conditions-modal />
</template>

<script>
import axios from 'axios'

import getConditions from '../../../vue-components/mixins/getCondition'
import TermModal from './TermModal'
import FormSuccessModal from './FormSuccessModal'
import SelectWithSearch from './SelectWithSearch'
import ConditionsModal from '../../../vue-components/modals/ConditionsModal'
import captchaMixin from '@/js/vue-components/mixins/captcha'

export default {
	name: 'FormNews',
	components: {
		TermModal,
		SelectWithSearch,
		FormSuccessModal,
		ConditionsModal,
	},
	mixins: [getConditions, captchaMixin],
	props: {
		regionsData: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			apiUrl: '/api/public/form/result/add/',
			idPersPr: 's3',
			title: 'Подпишитесь на рассылку',
			description:
				'Подпишитесь на информационную рассылку по залоговым объектам недвижимости',
			submitBtnText: 'Подписаться',
			formSubmiting: false,
			formSuccess: false,
			successData: {
				title: 'Вы успешно подписались на рассылку',
				description:
					'Мы будем держать вас в курсе лучших предложений и стартов продаж новых объектов недвижимости',
			},
			img: {
				src: '/static/v2/src/img/land/news-form.webp',
				alt: 'Картинка',
				width: '640',
				height: '636',
			},
			fields: {
				region: {
					dataId: 'region',
					id: 'news-form-region',
					type: 'text',
					label: 'Укажите регион, в котором хотели бы приобрести недвижимость',
					placeholder: 'Субъект РФ',
					value: '',
					name: 'form[region][]',
					clearBtn: false,
				},
				email: {
					dataId: 'email',
					id: 'news-form-email',
					type: 'email',
					label: 'E-mail',
					placeholder: 'Введите e-mail',
					value: '',
					name: 'form[email]',
					clearBtn: false,
				},
			},
			term: {
				modal: {
					apiUrl: '/api/v2/content/policy/?code=',
					response: {},
					visible: false,
				},
				field: {
					dataId: 'term',
					id: 'form-news-term',
					name: 'form[agreement_id]',
					value: 's3',
					label: 'Согласен (-на) на ',
					link: {
						href: '#',
						text: 'обработку персональных данных',
					},
				},
			},
			showPopupSuccess: false,
			adv: {
				field: {
					dataId: 'adv',
					id: 'form-news-adv',
					name: 'form[adv]',
					value: true,
					label: 'Согласен (-на) на ',
					link: {
						href: '#',
						text: 'получение рекламных материалов',
					},
				},
			},
			errors: {},
			errorResponse: {
				error: false,
				text: 'Ошибка отправки формы. Перезагрузите страницу и попробуйте еще раз',
			},
		}
	},

	methods: {
		hideSuccessModal() {
			this.formSuccess = false
		},

		regionsHandler(name, value) {
			this.fields.region.value = value
			this.delError('region')
		},

		showClear(field) {
			this.fields[field].value.length !== 0
				? (this.fields[field].clearBtn = true)
				: (this.fields[field].clearBtn = false)
		},

		clearField(field) {
			this.fields[field].value = ''
			this.fields[field].clearBtn = false
		},

		delError(field) {
			this.errors[field] = ''
		},

		validateFields(fieldValue) {
			const pattern = /^[\s]+$/
			if (fieldValue.length === 0 || pattern.test(fieldValue)) {
				return false
			}

			return true
		},

		validateEmail(email) {
			let re =
				/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			return re.test(email)
		},

		resetForm() {
			Object.values(this.fields).forEach(el => {
				el.value = ''
				el.clearBtn = false
			})

			this.$refs.term.checked = false
			this.errors = {}
		},

		checkForm() {
			this.errors = {}
			this.errorResponse.error = false

			Object.values(this.fields).forEach(el => {
				if (el.type === 'email') {
					if (!this.validateFields(el.value)) {
						this.errors[el.dataId] = 'Обязательное поле'
					} else if (!this.validateEmail(el.value)) {
						this.errors[el.dataId] =
							'Укажите корректный адрес электронной почты'
					}
				}

				if (el.type === 'text') {
					if (!this.validateFields(el.value)) {
						this.errors[el.dataId] = 'Обязательное поле'
					}
				}
			})

			if (!this.$refs.term.checked) {
				this.errors[this.term.field.dataId] = 'Примите согласие'
			}

			if (!this.$refs.adv.checked) {
				this.errors[this.adv.field.dataId] = 'Примите согласие'
			}

			if (Object.values(this.errors).length === 0) {
				return true
			}
		},

		resetSubmitButton() {
			this.formSubmiting = false
			this.submitBtnText = 'Подписаться'
		},

		submitHandler() {
			if (!this.checkForm()) return

			this.formSubmiting = true
			this.submitBtnText = 'Отправка...'

			//- вызывает из ./mixins/captcha
			this.initCaptcha()
		},

		submitFormAfterCaptchaCheck(token) {
			let formData = new FormData(newsForm)
			axios({
				method: 'post',
				url: this.apiUrl,
				data: formData,
			})
				.then(response => {
					this.resetSubmitButton()

					if (!response.data.success) {
						this.errorResponse.error = true
						return
					}

					this.resetForm()
					this.formSuccess = true
				})
				.catch(error => {
					this.resetSubmitButton()
					this.errorResponse.error = true
				})
		},

		getTerm() {
			new Promise(resolve => {
				axios
					.get(this.term.modal.apiUrl + this.term.field.value)
					.then(response => {
						this.term.modal.response = response.data
					})
					.catch(() => {})
			})
		},

		termModalShow() {
			this.term.modal.visible = true
		},

		termModalHide() {
			this.term.modal.visible = false
		},

		showPersModal(condId='s3') {
			this.contentPersPr = '';
			this.idPersPr = condId;
			this.showModal();
		}
	},
	created() {
		this.getTerm()
	},
}
</script>
